import { React, useEffect, useState } from "react";
import { toast } from "react-toastify";
import api from "../../../api/api";







const EmployeeDetails = () => {
  const [employe, setEmploye] = useState()
  const [viewMore, setViewMore] = useState(true)

  useEffect(() => {

    api
      .get("/info/employee-details/")
      .then((response) => {
        setEmploye(response.data)
      })
      .catch((err) => {
        toast.error("Something went wrong");
      });


  }, [])



  return (
    <div className="w-padding mt-10">
      <div className="max-w">
        <div className="text-center">
          <h1 className="sub-title-style">कर्मचारिको बिबरन</h1>
          <div className="bg-primary-blue mx-auto mt-1 h-1 w-[20%] rounded-full" />
        </div>
        {/* teams  */}

        <div className="mt-10 grid gap-6 text-center sm:grid-cols-2 lg:grid-cols-3 lg:gap-12 2xl:!grid-cols-4">
          {
            employe?.slice(0, `${viewMore ? 10 : employe.length}`).map((item, index) => {
              return (
                <div key={index} className="team-card group shadow-xl">
                  <div className="card-image-clip animation mx-auto h-40 w-40 overflow-hidden shadow-2xl">
                    <img
                      className="h-full w-full object-cover"
                      src={item.image}
                      alt=""
                    />
                  </div>
                  {/* name  */}
                  <h1 className="text-primary-red font-Rakkas text-xl font-semibold underline">
                    {item.name}
                  </h1>
                  <div className="">
                    <p className="text-primary-red font-Acme mt-1 text-left font-bold">
                      Post:
                      <span className="text-primary-blue font-normal"> {item.designation}</span>
                    </p>
                    <p className="text-primary-red font-Acme mt-1 text-left font-bold">
                      Address:
                      <span className="text-primary-blue font-normal">
                        {item.address}
                      </span>
                    </p>
                    <p className="text-primary-red font-Acme mt-1 text-left font-bold">
                      Contact:
                      <span className="text-primary-blue font-normal"> {item.contact_number}</span>
                    </p>
                    <p className="text-primary-red flex flex-wrap font-Acme mt-1 text-left font-bold">
                      Email:
                      <span className="text-primary-blue font-normal">
                        {item.email}
                      </span>
                    </p>
                  </div>
                  {/* <div className="mt-5">
                  <a
                    href="./staff-details.html"
                    className="card-button font-Berkshire"
                  >
                    View Details
                  </a>
                </div> */}
                </div>

              )
            })
          }
        </div>

        {/* view more  */}
        <div className="mt-10 text-white flex justify-center">
          {viewMore ? <button className=" bg-primary-red px-2 rounded-xl " onClick={() => setViewMore(false)}>View More</button> :
            <button className=" bg-primary-red rounded-xl px-2" onClick={() => setViewMore(true)}>View Less</button>
          }
        </div>
      </div>
    </div>
  );
};

export default EmployeeDetails;
